<template>
  <form>
    <div class="row">
      <div class="col-md-6 order-md-1">
        <div class="mb-4">
          <star-rating
              v-if="showRating"
              :font-size="1.3"
              :show-title="true"
              v-model="form.rating"
          ></star-rating>
          <input type="hidden" v-model="form.rating"  name="rating" :class="errors.get('rating') ? 'is-invalid':''">
          <div class="invalid-feedback" v-text="errors.get('rating')"></div>
        </div>
        <section class="b-comment-form__upload mb-4">
          <label class="button-upload " for="inputfile" v-if="!form.image">
            <i class="button-upload__icon button-upload__icon--contest">
              <svg viewBox="0 0 25 25">
                <use xlink:href="/assets/site/images/sprites.svg?ver=19#sprite-contest-profile"></use>
              </svg>
            </i>
            <span class="button-upload__text">Загрузить фото вашего профиля (необязательно)</span>
            <input type="file" name="file"  id="inputfile" class="button-upload__input" @change="fileChangeHandler" />
          </label>
          <div v-else class="button-upload__preview b-comment-form__preview-wrap">
            <figure class="b-comment-form__preview" :style="{ backgroundImage: `url(${form.image})` }">
            </figure>

            <button class="btn b-comment-form__remove-img-btn" @click="removeImage">Удалить фото</button>
          </div>
        </section>

      </div>
      <div class="col-md-6">
        <div class="mb-4">
          <input
              name="building_name"
              placeholder="Выбрать жилой комплекс"
              type="text"
              class="form-control"
              :class="errors.get('building_id') ? 'is-invalid':''"
              v-model="building_item.name"
              readonly
              style="cursor: pointer"
              @click.self="$emit('show-modal')"
          >
          <div class="invalid-feedback" v-text="errors.get('building_id')"></div>
        </div>

        <div class="form-group">


          <input name="name" placeholder="ФИО" type="text"
                 v-model="form.name" class="form-control" :class="errors.get('name') ? 'is-invalid':''">
          <div class="invalid-feedback" v-text="errors.get('name')"></div>
        </div>
        <div class="form-group">
          <input name="email" placeholder="E-mail" type="email"
                 v-model="form.email" class="form-control" :class="errors.get('email') ? 'is-invalid':''">
          <div class="invalid-feedback" v-text="errors.get('email')"></div>
        </div>

      </div>
    </div>
    <div class="form-group mb-4">
      <vue-editor v-model="form.comment" :editor-toolbar="customToolbar"/>
      <textarea style="display: none" placeholder="Текст отзыва"
                class="form-control b-comment-form__input" v-model="form.comment" name="comment"  rows="1"
                :class="errors.has('comment') ? 'is-invalid':''"></textarea>
      <div class="invalid-feedback"  v-text="errors.get('comment')"></div>
      <span style="font-size: 13px">*Минимальный объем текста отзыва - 500 символов.</span>
    </div>
    <div class="mb-4">
      <label class="form-checkbox" :class="errors.get('conf_agree') ? 'is-invalid':''">
          <span class="modal__conf-text">
               Согласен (-на) с
          <a class="landing-questions__link" href="/privacy" target="_blank">политикой
              конфиденциальности.</a>
          </span>
        <input type="checkbox" v-model="form.conf_agree" name="conf_agree" class="form-checkbox__input" checked>
        <span class="form-checkbox__checkmark"></span>
      </label>
      <div class="invalid-feedback" v-text="errors.get('conf_agree')"></div>
    </div>
    <label class="">Фотографии к отзыву:</label>
    <div class="mb-4 d-flex flex-wrap">
      <el-upload
          action=""

          class="avatar-uploader"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="uploadPanorama"
      >
        <i  class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <draggable v-model="form.panoramas" draggable=".panorama-gallery__item" tag="div"  :class="['panorama-gallery']"  @end="endSort">
        <div   v-for="(panorama, index) in form.panoramas"
               class="panorama-gallery__item">
          <img :src="panorama.url"
          />
          <span class="panorama-gallery__item-actions">
                      <span
                          class="panorama-gallery__item-delete"
                          @click="handleRemove(panorama)"
                      >
                <i class="el-icon-delete"></i>
                      </span>
                    </span>
        </div>
      </draggable>
    </div>
    <button class="btn button-red user-auth__btn" @click.prevent="storeReview">Отправить</button>
  </form>
</template>
<script>
import { VueEditor } from "vue2-editor";
import StarRating from "../../star-rating/StarRating";
import { Errors } from  '@/common/services/errors.js';
import draggable from 'vuedraggable';
import obj2fd from "obj2fd";
export default {
  components: {
    'StarRating':StarRating,
    'draggable':draggable,
    VueEditor

  },
  props:['building_item'],
  data(){
    return {
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
      form: {
        rating:0,
        image:"",
        conf_agree:false,
        name:"",
        email:"",
        password:"",
        comment:"",
        building_id:null,
        panoramas:[],
      },
      showRating:true,
      errors: new Errors(),
    }
  },
  methods: {
    endSort(e){

    },
    storeReview() {
      this.$root.isLoading = true;
      let _this = this;
      this.errors.clear();
      let formData = obj2fd(_this.form);
      axios.post('/api/contest/store-review', formData,{headers: {
          'Content-Type': 'multipart/form-data'
        }})
      .then((response) => {
        this.$root.isLoading = false;
        this.errors.clear();
        this.showRating =false;
        this.$emit('success-store');
        this.showRating = true;
        this.form = {
          rating:0,
          image:"",
          conf_agree:false,
          name:"",
          email:"",
          password:"",
          comment:"",
          building_id:null,
          panoramas:[],
        }
      })
        .catch((error) => {
          this.$root.isLoading = false;
          this.errors.record(error.response.data.errors);
        });
    },
    handleRemove(panorama) {
      this.form.panoramas.splice(this.form.panoramas.indexOf(panorama), 1);
    },
    fileChangeHandler(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.createImage(files[0]);
    },
    getBuildingId(id) {
      this.form.building_id = id;
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      this.form['imageName'] = file.name;
      reader.onload = (e) => {
        vm.form.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage() {
      this.form.image = '';
    },
    uploadPanorama(file){
      let cond = this.beforePanoramaUpload(file.raw);
      if(cond){
        this.createPanorama(file);
      }
    },
    beforePanoramaUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      if (!isJPG && !isPNG) {
        this.$message.error('Картинка должна быть в формате jpeg или png');
      }
      return (isJPG || isPNG);
    },

    createPanorama(file) {
      let preview = URL.createObjectURL(file.raw);
      let item =  {
        id:"",
        url:preview,
        file:file.raw
      }
      this.form.panoramas.push(item);
    },
  },
}
</script>
<style scoped>
.avatar-uploader  {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>